import { useNavigate } from "react-router-dom";

import { ROUTES } from "~/const";
import Badge from "~/components/Badge";
import HamburgerMenu from "~/components/HamburgerMenu";
import LangSwitcher from "~/components/LangSwitcher";
import { userStore } from "~/stores/user";

import "./style.less";

export default function Header() {
	const navigate = useNavigate();
	const userData = userStore(userState => userState.user);

	function badgeOnClick() {
		navigate(ROUTES.profile);
	}

	return <div className="header">
		<div className="logo"></div>
		<div className="user-container">
			{/* prihlaseny uzivatel ma prepinac v nastaveni */}
			{ !userData.email && <div className="header__lang">
				<LangSwitcher />
			</div> }
			{/* neprihlasenemu uzivateli se odznak nezobrazuje */}
			{ userData.email && <Badge userData={userData} onClick={badgeOnClick} /> }
			<HamburgerMenu className="hamburger-menu"/>
		</div>
	</div>;
}
